/* eslint-disable no-unused-vars */
/**
 * © [2022] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
export const GET_ERROR_MSG_CMS = 'GET_ERROR_MSG_CMS';
export const GET_FROM = 'GET_FROM';
export const GET_QUARTERLY_CMS = 'GET_QUARTERLY_CMS';
export const SET_REFRESH_DATA_CMS = 'SET_REFRESH_DATA_CMS';
export const REFRESH_DATA_CMS_DISPLAY = 'REFRESH_DATA_CMS_DISPLAY';
